import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Navbar as BootstrapNavbar, Nav as BNav } from "react-bootstrap";
import Container from "react-bootstrap/Container";
import { LinkContainer } from "react-router-bootstrap";
import CustomNavbarToggle from "../../atoms/CustomNavbarToggle/CustomNavbarToggle";
import NavItem from "../../molecules/NavItem/NavItem";
import BrandLogo from "../../atoms/BrandLogo/BrandLogo";
import "./Nav.css";

const Nav = ({ routes }) => {
    const [expanded, setExpanded] = useState(false);
    const [isMobile, setIsMobile] = useState(window.innerWidth < 820);
    const [isSticky, setIsSticky] = useState(false);

    const toggleNavbar = () => setExpanded((prevExpanded) => !prevExpanded);
    const location = useLocation();

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth < 820);
        };
        window.addEventListener("resize", handleResize);
        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);

    useEffect(() => {
        const handleScroll = () => {
            const scrollThreshold = 40; // Adjust scroll threshold as needed
            const currentScrollY = window.scrollY;
            setIsSticky(currentScrollY > scrollThreshold);
        };

        window.addEventListener("scroll", handleScroll);
        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);

    return (
        <BootstrapNavbar
            collapseOnSelect
            expand="md"
            className={`navbar-dark w-100 ${isSticky ? "sticky" : ""}`}
            expanded={expanded}
        >
            <Container>
                <LinkContainer to="/" onClick={() => setExpanded(false)}>
                    <BrandLogo color="blue" />
                </LinkContainer>

                <CustomNavbarToggle
                    onClick={() => toggleNavbar()}
                    active={expanded}
                />

                <BootstrapNavbar.Collapse
                    id="navbar"
                    className="mx-2 mt-3 ccl-navbar-collapse"
                >
                    <BNav className="w-100 d-flex justify-content-end">
                        {Object.entries(routes).map(([path, text]) => (
                            <NavItem
                                key={path}
                                to={path}
                                onClick={
                                    isMobile ? () => toggleNavbar() : undefined
                                }
                                className={`rounded ccl-blue h-scale-5 ccl-nav-item fs-5 ${
                                    location.pathname === path
                                        ? "active-route"
                                        : ""
                                    }`}
                                
                            >
                                {text}
                            </NavItem>
                        ))}
                    </BNav>
                </BootstrapNavbar.Collapse>
            </Container>
        </BootstrapNavbar>
    );
};

export default Nav;
